




















import { SfRadio } from '@storefront-ui/vue';
import { ref, onMounted, defineComponent } from '@nuxtjs/composition-api';
import usePaymentProvider from '~/modules/checkout/composables/usePaymentProvider';
import type { AvailablePaymentMethod } from '~/modules/GraphQL/types';

const ALLOWED_PAYMENT_METHOD_CODES = ["cashondelivery",]

export default defineComponent({
  name: 'VsfPaymentProvider',
  components: {
    SfRadio,
  },
  emits: ['status'],
  setup(_props, { emit }) {
    const paymentMethods = ref<AvailablePaymentMethod[]>([]);
    const { load, save } = usePaymentProvider();
    const selectedPaymentMethodCode = ref<string | null>(null);

    onMounted(async () => {
      paymentMethods.value = await load();

      paymentMethods.value = paymentMethods.value.filter((payment) => ALLOWED_PAYMENT_METHOD_CODES.includes(payment.code));
    });

    const definePaymentMethods = async (paymentMethodCode: string) => {
      paymentMethods.value = await save({
        paymentMethod: {
          code: paymentMethodCode,
        },
      });

      paymentMethods.value = paymentMethods.value.filter((payment) => ALLOWED_PAYMENT_METHOD_CODES.includes(payment.code));

      selectedPaymentMethodCode.value = paymentMethodCode;

      emit('status', paymentMethodCode);
    };

    return {
      paymentMethods,
      selectedPaymentMethodCode,
      definePaymentMethods,
    };
  },
});
